/**
 * Single shared API client. In demo mode (opt-in: VITE_MOCK_MODE === 'true' at
 * build time or mockMode "true" in the runtime config) we return a MockApiClient
 * backed by the in-memory @field-iq/mock-demo store; otherwise we wire the real
 * fetch-based ApiClient against the backend.
 */
import { AUTH_JWT_KEY, clearAuth } from '../auth/auth';
import { MOCK_MODE } from '../mockMode';
import { apiHost } from '../runtimeConfig';
import { ApiClient } from './client';
import { MockApiClient } from './mock-client';

export { MOCK_MODE };

/**
 * Hosts for the real backend. Resolved in `../runtimeConfig` (runtime
 * `config.js` from the apps/web container, then VITE_API_URL / VITE_WS_URL, then
 * the legacy VITE_API_HOST / VITE_WS_HOST, then localhost) and re-exported here
 * so existing imports keep working.
 */
export { apiHost, wsHost } from '../runtimeConfig';

export const api: ApiClient | MockApiClient = MOCK_MODE
  ? new MockApiClient()
  : new ApiClient(
      apiHost,
      () => localStorage.getItem(AUTH_JWT_KEY) ?? undefined,
      // A 401 means the session is gone (expired, or signed out elsewhere):
      // drop it and let the gate show sign-in, rather than a page of errors.
      () => {
        clearAuth();
        window.location.assign('/');
      },
    );
